import axios from "axios";
import { getBaseUrl } from "../../utils/common";

// const localConfig = "http://localhost:7000";

// const devConfig = "https://api.dev.skoda.ap.appstore.visteoncloud.com";

// const prestagingConfig = "https://qaapi.visteoncloud.com";

// const prodConfig = "https://api.visteoncloud.com";

// const stagingConfig = "https://stagingapi.visteoncloud.com";

// function getBaseUrl(): string {
//     switch (process.env.APP_ENV) {
//         case "production":
//             return prodConfig;
//         case "staging":
//             return stagingConfig;
//         case "prestaging":
//             return prestagingConfig;
//         case "development":
//             return devConfig;
//         default:
//             return localConfig;
//     }
// }

export default axios.create({
    baseURL: getBaseUrl(),
    headers: {
        "Content-type": "application/json",
    },
});
